import { Panel } from 'components/ui/index';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Actions, CriteriaSection, FormatSection, NameSection, TableSetupSection } from '../components/index';

const ReportFilters = () => (
  <Panel
    panelTitle={<FormattedMessage id="page.ReportFilters.panelName" />}
    panelClasses="report-theme-panel"
  >
    <NameSection />
    <CriteriaSection />
    <FormatSection />
    <TableSetupSection />
    <Actions />
  </Panel>
);

const mapStateToProps = ({ global }) => ({
  lang: global.language,
});
const enhancers = compose(
  injectIntl,
  connect(mapStateToProps),
);

export default enhancers(ReportFilters);



// WEBPACK FOOTER //
// ./src/views/ReportFilters/container/index.jsx